// @ts-nocheck

import get from 'lodash/get';

const normalizeThemePath = (value) => {
  if (typeof value !== 'string') return null;

  return value
    .trim()
    .replace(/\[(.+?)\]/g, '.$1')
    .replace(/^palette\./, '');
};

const resolvePath = (theme, value) => {
  const path = normalizeThemePath(value);
  if (!path) return undefined;

  const directValue = get(theme, path);
  if (directValue != null) return directValue;

  return get(theme.palette, path);
};

export const resolveThemeColor = (theme, value, fallback) => {
  if (typeof value === 'function') {
    return value(theme);
  }

  if (value != null) {
    if (typeof value !== 'string') return value;

    const resolvedValue = resolvePath(theme, value);
    if (resolvedValue != null) return resolvedValue;

    return value;
  }

  if (typeof fallback === 'function') {
    return fallback(theme);
  }

  if (fallback == null) return fallback;

  if (typeof fallback !== 'string') return fallback;

  const resolvedFallback = resolvePath(theme, fallback);
  return resolvedFallback ?? fallback;
};

export const resolveNodeColors = (
  theme,
  data,
  schemes,
  fallbackScheme = 'default'
) => {
  const scheme =
    schemes?.[data?.colorScheme] ?? schemes?.[fallbackScheme] ?? {};

  return {
    bg: resolveThemeColor(
      theme,
      data?.bgColor ?? data?.color ?? data?.colors?.background,
      scheme.bg
    ),
    border: resolveThemeColor(
      theme,
      data?.borderColor ?? data?.colors?.border,
      scheme.border
    ),
    text: resolveThemeColor(
      theme,
      data?.textColor ?? data?.colors?.text,
      scheme.text
    ),
    handle: resolveThemeColor(
      theme,
      data?.handleColor ?? data?.colors?.handle,
      'solyticsFlow.node.handleColor'
    ),
  };
};
